<template>
  <div v-if="$tools.isDefined(block)" class="pa-4">
    <div class="body-2">
      <slot/>
    </div>
    <v-btn depressed small class="mt-2" @click="$emit('close')">Закрыть</v-btn>
  </div>
  <div v-else class="text-center py-4">
    <v-icon class="mb-2" color="grey">
      {{typeof icon==='undefined' ? 'mdi-information-outline' : icon}}
    </v-icon>
    <div class="muted1 body-2">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: ['icon','block']
}
</script>
